import "./Footer.scss";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className="footer">
      <div className="footer-text">
        Copyright (c) {year} mbrdi.co.in All rights reserved.
        <a href="#/privacy"> Privacy Statement</a>
      </div>
    </div>
  );
}
